var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeygirl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 369.641,
    height: 360.194,
    viewBox: "0 0 369.641 360.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Private_data-pana",
    "data-name": "Private data-pana",
    transform: "translate(-28.015 -31.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-9",
    transform: "translate(28.015 31.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15250",
    "data-name": "Path 15250",
    d: "M428.739,112.3l-.982.1a22.261,22.261,0,0,0-18.6,13.582,21.819,21.819,0,0,0-.974,3.02,23.365,23.365,0,0,0,5.8,21.287c3.15,3.247,7.363,5.8,9.1,9.97,2.257,5.431-.5,11.48-3.2,16.659s-5.439,11.236-3.158,16.651c1.429,3.4,4.628,5.8,8.045,7.234,9.052,3.783,19.907,1.437,27.6-4.49s12.478-14.971,14.873-24.356c3.361-13.152,2.224-27.749-4.725-39.545S442.443,112.153,428.739,112.3Z",
    transform: "translate(-99.432 -46.564)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15251",
    "data-name": "Path 15251",
    d: "M68.262,128.753l.812.2a18.916,18.916,0,0,1,13.875,13.8,18.379,18.379,0,0,1,.43,2.663,19.85,19.85,0,0,1-7.615,17.13c-3.061,2.346-6.925,3.921-8.93,7.2-2.59,4.27-1.055,9.7.544,14.394s3.134,10.132.52,14.394c-1.624,2.663-4.636,4.27-7.688,5.033-8.119,2.013-16.895-1.348-22.594-7.307s-8.557-14.175-9.361-22.366c-1.128-11.471,1.7-23.584,9.052-32.6S56.775,126.861,68.262,128.753Z",
    transform: "translate(-28.015 -49.59)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 15.182,
    cy: 15.182,
    r: 15.182,
    transform: "translate(235.465)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 15.182,
    cy: 15.182,
    r: 15.182,
    transform: "translate(13.212 267.346) rotate(-77.22)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-9",
    transform: "translate(45.636 391.077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15252",
    "data-name": "Path 15252",
    d: "M374.915,474.661c0,.114-72.807.211-162.589.211s-162.605-.1-162.605-.211,72.79-.211,162.605-.211S374.915,474.539,374.915,474.661Z",
    transform: "translate(-49.72 -474.45)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphic--inject-9",
    transform: "translate(71.972 50.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15253",
    "data-name": "Path 15253",
    d: "M384.869,93.76c.073.089-10.043,8.443-22.586,18.673s-22.781,18.4-22.854,18.315,10.034-8.435,22.586-18.673S384.788,93.671,384.869,93.76Z",
    transform: "translate(-130.565 -62.431)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15254",
    "data-name": "Path 15254",
    d: "M402.4,256.707c-.041.114-13.128-4.579-29.227-10.465s-29.154-10.757-29.081-10.863,13.128,4.571,29.227,10.465S402.47,256.6,402.4,256.707Z",
    transform: "translate(-131.442 -89.076)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15255",
    "data-name": "Path 15255",
    d: "M82.16,123.16c.057-.106,14.159,7.307,31.484,16.61s31.346,16.895,31.289,16.992-14.151-7.307-31.484-16.619S82.1,123.257,82.16,123.16Z",
    transform: "translate(-82.16 -67.962)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15256",
    "data-name": "Path 15256",
    d: "M88.42,267.1c0-.114,11.545-4.563,25.866-9.937s25.979-9.645,26.02-9.539-11.536,4.554-25.866,9.937S88.461,267.2,88.42,267.1Z",
    transform: "translate(-83.338 -91.379)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15257",
    "data-name": "Path 15257",
    d: "M241.323,268.99A70.485,70.485,0,1,1,311.8,198.508,70.487,70.487,0,0,1,241.323,268.99Zm0-140.15a69.68,69.68,0,1,0,0-.024Z",
    transform: "translate(-98.843 -68.877)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15258",
    "data-name": "Path 15258",
    d: "M326.066,192.918s0-.487-.057-1.445c0-.479,0-1.072-.057-1.778s0-1.526-.122-2.436-.162-1.965-.252-3.109-.3-2.387-.471-3.743c-.382-2.7-.966-5.788-1.81-9.223a88.984,88.984,0,0,0-3.653-11.228,85.919,85.919,0,0,0-6.194-12.535,90.172,90.172,0,0,0-22.626-25.273,87.569,87.569,0,0,0-16.992-10.156,86.683,86.683,0,0,0-20.459-6.495,90.407,90.407,0,0,0-34.845.4,95.433,95.433,0,0,0-11.885,3.394,89.141,89.141,0,0,0-41.331,31,88.2,88.2,0,0,0-7.25,11.666c-.511,1.039-1.088,2.046-1.542,3.109l-1.437,3.174c-.861,2.168-1.745,4.335-2.436,6.568a86.357,86.357,0,0,0-3.385,13.826,95.325,95.325,0,0,0-1.169,14.3,96.42,96.42,0,0,0,1.161,14.313A86.144,86.144,0,0,0,152.639,221c.706,2.241,1.624,4.408,2.436,6.576l1.437,3.174c.455,1.072,1.039,2.078,1.551,3.109a86.866,86.866,0,0,0,7.242,11.674,89.174,89.174,0,0,0,41.339,31,95.168,95.168,0,0,0,11.926,3.361,90.376,90.376,0,0,0,34.845.4,88.93,88.93,0,0,0,37.41-16.619,90,90,0,0,0,22.6-25.289,85.922,85.922,0,0,0,6.194-12.535,88.988,88.988,0,0,0,3.653-11.187c.812-3.434,1.429-6.495,1.81-9.215.171-1.356.357-2.6.471-3.743s.17-2.184.252-3.117.106-1.745.122-2.436.041-1.3.057-1.778a13.969,13.969,0,0,1,.057-1.445v3.223a20.365,20.365,0,0,1-.106,2.436c-.106.9-.146,1.973-.227,3.117s-.284,2.395-.447,3.751c-.373,2.7-.95,5.8-1.778,9.239a88.968,88.968,0,0,1-3.629,11.22,85.348,85.348,0,0,1-6.178,12.584,90.181,90.181,0,0,1-22.626,25.4,89.032,89.032,0,0,1-60.6,18.023,87.232,87.232,0,0,1-11.967-1.664,93.148,93.148,0,0,1-11.959-3.4,89.466,89.466,0,0,1-41.542-31.118,88.492,88.492,0,0,1-7.307-11.723c-.511-1.039-1.1-2.054-1.559-3.126s-.958-2.127-1.445-3.191c-.861-2.176-1.754-4.352-2.436-6.6a86.187,86.187,0,0,1-3.4-13.8,88.947,88.947,0,0,1,0-28.748,87.2,87.2,0,0,1,3.41-13.8c.706-2.249,1.624-4.425,2.436-6.6.487-1.064.966-2.127,1.445-3.191s1.039-2.078,1.559-3.126a88.1,88.1,0,0,1,7.307-11.715A89.482,89.482,0,0,1,206.529,109a94.532,94.532,0,0,1,11.942-3.442,91.106,91.106,0,0,1,34.983-.373,86.665,86.665,0,0,1,20.524,6.495A87.679,87.679,0,0,1,291.026,121.9a90.222,90.222,0,0,1,22.634,25.4,86.165,86.165,0,0,1,6.178,12.584,88.969,88.969,0,0,1,3.629,11.22c.812,3.442,1.4,6.544,1.778,9.247.162,1.356.333,2.6.447,3.743s.162,2.192.227,3.126.1,1.745.106,2.436,0,1.3,0,1.778C326.074,192.431,326.066,192.918,326.066,192.918Z",
    transform: "translate(-94.486 -64.296)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15259",
    "data-name": "Path 15259",
    d: "M235.035,290.494v-.812A102.569,102.569,0,1,0,132.442,187.1l-.812.008A103.381,103.381,0,1,1,235.011,290.5Z",
    transform: "translate(-91.468 -60.545)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15260",
    "data-name": "Path 15260",
    d: "M257.67,283.6v-4.059a87.063,87.063,0,0,0,0-174.126V101.36a91.122,91.122,0,0,1,0,182.244Z",
    transform: "translate(-115.182 -63.861)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15261",
    "data-name": "Path 15261",
    d: "M339.631,186.737h-4.059a100.943,100.943,0,1,0-201.887,0H129.63a105,105,0,0,1,210,0Z",
    transform: "translate(-91.091 -60.169)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15262",
    "data-name": "Path 15262",
    d: "M232.819,303.4a116.988,116.988,0,0,1,0-233.975v4.059a112.928,112.928,0,1,0,112.9,112.928h4.059A117.086,117.086,0,0,1,232.819,303.4Z",
    transform: "translate(-88.497 -57.851)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15263",
    "data-name": "Path 15263",
    d: "M257.188,374.342H255.15v-.812h2.03Z",
    transform: "translate(-114.708 -115.069)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15264",
    "data-name": "Path 15264",
    d: "M217.342,314.1c-1.356-.106-2.736-.235-4.059-.39l.089-.812c1.348.146,2.72.276,4.059.382Zm-12.178-1.518c-1.356-.235-2.72-.5-4.059-.771l.171-.812c1.315.276,2.663.536,4.011.771Zm-12.04-2.7c-1.307-.357-2.639-.747-3.946-1.153l.244-.812c1.3.406,2.614.812,3.921,1.153Zm-11.731-3.848c-1.283-.487-2.565-1.007-3.832-1.534l.317-.747c1.25.528,2.533,1.039,3.808,1.526Zm-11.358-4.92c-1.226-.609-2.436-1.242-3.661-1.892l.382-.714c1.2.641,2.436,1.275,3.637,1.884ZM159.246,295.1c-1.161-.723-2.33-1.469-3.458-2.224l.447-.682c1.128.755,2.289,1.5,3.442,2.216Zm-10.156-7.006c-1.088-.812-2.176-1.681-3.247-2.549l.52-.625c1.047.852,2.127,1.7,3.207,2.525Zm-9.45-7.94c-1.015-.934-2.013-1.892-2.979-2.841l.568-.576c.958.942,1.957,1.892,2.963,2.825Zm-8.654-8.833c-.909-1.023-1.819-2.062-2.7-3.109l.625-.52c.869,1.039,1.77,2.078,2.679,3.093Zm-7.778-9.564c-.812-1.112-1.624-2.233-2.387-3.353l.666-.455c.763,1.1,1.559,2.224,2.371,3.32Zm-6.836-10.262c-.7-1.161-1.4-2.362-2.062-3.556l.739-.406c.658,1.185,1.348,2.371,2.038,3.532Zm-5.829-10.854c-.593-1.234-1.169-2.492-1.713-3.735l.747-.325c.536,1.234,1.112,2.484,1.7,3.71Zm-4.766-11.366c-.471-1.283-.926-2.59-1.348-3.881l.812-.26c.422,1.291.869,2.59,1.34,3.864Zm-3.67-11.78c-.341-1.323-.666-2.663-.966-3.994l.812-.179c.292,1.323.617,2.655.958,3.97Zm-2.484-12.064c-.211-1.34-.406-2.712-.585-4.059l.812-.1c.17,1.348.365,2.712.576,4.059Zm-1.388-12.291c-.089-1.356-.154-2.744-.195-4.108h.812c0,1.356.106,2.728.195,4.059Zm.576-12.275H98c.049-1.372.114-2.752.195-4.116l.812.057C98.95,178.126,98.893,179.5,98.812,180.862Zm.958-12.226-.812-.1c.17-1.356.365-2.728.576-4.059l.812.13c-.179,1.323-.373,2.679-.544,4.027Zm2.111-12.072-.812-.179c.3-1.331.625-2.679.966-3.994l.812.2c-.317,1.307-.641,2.647-.934,4.011Zm3.247-11.821-.771-.252c.43-1.3.885-2.606,1.348-3.9l.763.276c-.43,1.283-.885,2.59-1.307,3.873Zm4.384-11.471-.747-.325c.552-1.25,1.128-2.509,1.713-3.751l.739.349c-.56,1.234-1.128,2.484-1.672,3.726Zm5.456-11-.706-.39q1-1.8,2.062-3.572l.69.422c-.666,1.161-1.356,2.354-2.013,3.54Zm6.495-10.416-.674-.463c.812-1.12,1.583-2.249,2.395-3.353l.649.479c-.787,1.1-1.591,2.216-2.354,3.337Zm7.428-9.742-.617-.528c.877-1.039,1.786-2.086,2.7-3.109l.6.544c-.885,1-1.786,2.038-2.663,3.077Zm8.321-9.012-.568-.576c.966-.95,1.973-1.908,2.971-2.841l.552.6c-.982.909-1.973,1.859-2.939,2.8Zm9.133-8.175-.511-.633c1.055-.861,2.143-1.713,3.247-2.541l.5.649c-1.088.8-2.168,1.656-3.215,2.509Zm9.856-7.307-.447-.674c1.12-.755,2.289-1.5,3.45-2.224l.43.69c-1.145.731-2.3,1.478-3.418,2.224Zm10.513-6.259-.382-.723c1.2-.641,2.436-1.275,3.645-1.883l.365.731C169.134,70.06,167.917,70.685,166.715,71.359Zm11.049-5.277-.317-.747c1.258-.528,2.541-1.047,3.808-1.526l.292.755c-1.258.455-2.533.966-3.783,1.494Zm11.5-4.2-.244-.771c1.307-.406,2.639-.812,3.946-1.161l.219.812c-1.307.309-2.639.69-3.921,1.1Zm11.837-3.1-.162-.812c1.34-.284,2.7-.544,4.059-.812l.146.812C203.817,58.248,202.461,58.508,201.1,58.784Zm12.1-1.932-.089-.812c1.356-.154,2.736-.284,4.059-.39l.065.812c-1.291.106-2.663.284-4.011.39Z",
    transform: "translate(-85.14 -55.26)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15265",
    "data-name": "Path 15265",
    d: "M255.16,55.982V55.17H257.2v.812Z",
    transform: "translate(-114.71 -55.17)",
    fill: "#ffc100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-9",
    transform: "translate(67.522 122.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15266",
    "data-name": "Path 15266",
    d: "M79.25,410.084s5.448,3.523,7.964,3.4S99.627,401.1,99.627,401.1l-5.155-3.9-12.7,2.1L79.266,409.97",
    transform: "translate(-77.162 -191.768)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15267",
    "data-name": "Path 15267",
    d: "M206.771,191.46a25.281,25.281,0,0,1-5.74,23.462c-2.606,2.809-5.926,5.107-7.575,8.565-1.827,3.832-1.234,8.338-2.046,12.511s-4.352,8.606-8.411,7.6c3.848,5.683,9.693,9.831,15.961,12.681s12.99,4.522,19.671,6.186c3.718.917,7.729,1.827,11.285.4,4.6-1.843,6.893-6.9,8.736-11.5l16.058-40.114",
    transform: "translate(-96.683 -153.058)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15268",
    "data-name": "Path 15268",
    d: "M267.311,167.358a6.008,6.008,0,0,0-5.5-5.975L233.5,148.393c-10.221-.861-20.426,17.43-20.848,27.676a170.142,170.142,0,0,0,2.533,33.521c3.069,17,14.54,17.325,14.54,17.325l.974,27.505,35.527-.065Z",
    transform: "translate(-102.244 -144.95)",
    fill: "#d0937e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15269",
    "data-name": "Path 15269",
    d: "M221.85,198.771a2.192,2.192,0,0,0,2.16,2.16,2.095,2.095,0,0,0,2.208-2.022,2.184,2.184,0,0,0-2.151-2.16,2.087,2.087,0,0,0-2.216,2.022Z",
    transform: "translate(-103.992 -154.052)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15270",
    "data-name": "Path 15270",
    d: "M218.394,191.959c.235.2,1.957-.073,4.254.438s3.881,1.486,4.157,1.4c.13-.041-.1-.365-.812-.812a10.651,10.651,0,0,0-3.3-1.3,9.434,9.434,0,0,0-3.41-.162C218.548,191.65,218.272,191.894,218.394,191.959Z",
    transform: "translate(-103.337 -153.053)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15271",
    "data-name": "Path 15271",
    d: "M249.19,197.371a2.192,2.192,0,0,0,2.16,2.168,2.095,2.095,0,0,0,2.208-2.021,2.192,2.192,0,0,0-2.151-2.168,2.1,2.1,0,0,0-2.216,2.022Z",
    transform: "translate(-109.136 -153.789)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15272",
    "data-name": "Path 15272",
    d: "M245.2,192.954c.341.081,1.827-1.112,4.278-1.827s4.49-.576,4.7-.812c.106-.114-.284-.317-1.177-.39a10.952,10.952,0,0,0-3.832.455A9.742,9.742,0,0,0,245.838,192C245.2,192.564,245.026,192.929,245.2,192.954Z",
    transform: "translate(-108.374 -152.766)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15273",
    "data-name": "Path 15273",
    d: "M233.6,208.448a15.4,15.4,0,0,0-3.84-.609c-.6-.049-1.169-.154-1.283-.568a3.093,3.093,0,0,1,.365-1.786c.536-1.469,1.1-3,1.681-4.619,2.33-6.568,4-11.959,3.735-12.056s-2.371,5.163-4.7,11.731c-.552,1.624-1.088,3.166-1.624,4.636a3.467,3.467,0,0,0-.26,2.371,1.51,1.51,0,0,0,1.055.9,4.059,4.059,0,0,0,1.023.114C232.134,208.619,233.6,208.594,233.6,208.448Z",
    transform: "translate(-105.069 -152.559)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15274",
    "data-name": "Path 15274",
    d: "M233.7,243.836a43.418,43.418,0,0,0,22.732-6.576s-5.009,12.551-22.107,11.317Z",
    transform: "translate(-106.222 -161.675)",
    fill: "#b5715a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15275",
    "data-name": "Path 15275",
    d: "M235.568,219.329a6.308,6.308,0,0,1,4.457-3.093,2.687,2.687,0,0,1,2.687,1.421,4.254,4.254,0,0,1-.292,3.921,3.6,3.6,0,0,1-3.523,1.8,6.024,6.024,0,0,1-2.988-1.843,2.086,2.086,0,0,1-.617-.812,1.413,1.413,0,0,1,.154-1.234",
    transform: "translate(-106.507 -157.716)",
    fill: "#884c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15276",
    "data-name": "Path 15276",
    d: "M241.9,214.84c-.39,0-.341,2.541-2.484,4.4s-4.871,1.624-4.871,2c0,.162.617.479,1.77.487a6.365,6.365,0,0,0,4.059-1.518,5.569,5.569,0,0,0,1.916-3.686C242.366,215.449,242.066,214.824,241.9,214.84Z",
    transform: "translate(-106.38 -157.457)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15277",
    "data-name": "Path 15277",
    d: "M242.995,179.335c.309.609,2.606,0,5.383,0s5.09.471,5.391-.146c.122-.292-.333-.812-1.3-1.348a9.344,9.344,0,0,0-8.208.1C243.312,178.482,242.865,179.043,242.995,179.335Z",
    transform: "translate(-107.966 -150.326)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15278",
    "data-name": "Path 15278",
    d: "M215.752,187.966c.528.528,2.533-.081,4.952-.17s4.481.252,4.944-.325c.195-.276-.138-.812-1.047-1.283a8.119,8.119,0,0,0-4.059-.812,8,8,0,0,0-3.921,1.177C215.793,187.155,215.525,187.715,215.752,187.966Z",
    transform: "translate(-102.83 -151.911)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15279",
    "data-name": "Path 15279",
    d: "M288.632,208.694c-1.469-7.566-6.065-31.808-12.835-44.449s-14.508-17.633-22.025-19.484A17.2,17.2,0,0,0,237.4,148.9c-3.3,3.1-4.254,11.918-4.254,11.918s18.129,3.58,24.437,13.72c7.258,11.642,9.085,17.544,9.085,17.544l2.436,6.406s1.916,31.183,1.283,37.345l27.229,9.831C291.774,233.642,290.109,216.284,288.632,208.694Z",
    transform: "translate(-106.118 -144.158)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15280",
    "data-name": "Path 15280",
    d: "M230,161.091s-11.95-.617-15.49,11.114c-1.624,5.309-1.786,20.743-1.786,20.743s-2.557-12.235-2.168-19.143,3.629-15.7,8.8-20.653c5.025-4.814,9.312-7.12,18.51-6.779,0,0-1.315,2.614-3.58,6.154C233.154,154.3,231.368,154.5,230,161.091Z",
    transform: "translate(-101.86 -144.569)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15281",
    "data-name": "Path 15281",
    d: "M274.25,203.1c.106-3.783,4.157-6.4,7.469-4.579,1.819.99,3.247,3.044,3.174,7.063-.187,10.692-10.887,8.3-10.9,7.989C274,213.412,274.136,207.526,274.25,203.1Z",
    transform: "translate(-113.802 -154.276)",
    fill: "#d0937e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15282",
    "data-name": "Path 15282",
    d: "M278.1,210.337c.049,0,.187.138.5.284a1.867,1.867,0,0,0,1.388.057c1.137-.4,2.119-2.176,2.208-4.059a6.186,6.186,0,0,0-.479-2.679,2.127,2.127,0,0,0-1.372-1.453.942.942,0,0,0-1.112.487c-.146.3-.081.511-.138.528s-.227-.179-.13-.617a1.137,1.137,0,0,1,.43-.666,1.413,1.413,0,0,1,1.031-.252,2.614,2.614,0,0,1,1.924,1.689,6.389,6.389,0,0,1,.593,3c-.106,2.151-1.25,4.149-2.8,4.571a2,2,0,0,1-1.7-.317C278.114,210.6,278.066,210.353,278.1,210.337Z",
    transform: "translate(-114.574 -155.032)",
    fill: "#884c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15283",
    "data-name": "Path 15283",
    d: "M246.292,144.49c0,.081-1.218.341-3.069,1.161a14.548,14.548,0,0,0-6.008,4.936,27.036,27.036,0,0,0-3.458,7.071c-.649,1.924-.974,3.15-1.047,3.126a3.882,3.882,0,0,1,.146-.877c.114-.56.333-1.356.617-2.338a24.42,24.42,0,0,1,3.4-7.234,14.614,14.614,0,0,1,3.085-3.182,14.345,14.345,0,0,1,3.142-1.778,11.194,11.194,0,0,1,1.307-.463,7.471,7.471,0,0,1,1.007-.276,3.362,3.362,0,0,1,.877-.146Z",
    transform: "translate(-106.035 -144.221)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15284",
    "data-name": "Path 15284",
    d: "M284.346,230.229a.973.973,0,0,1-.1-.227c-.065-.171-.138-.4-.244-.674a17.9,17.9,0,0,1-.7-2.679,36.055,36.055,0,0,1,0-10.132c.219-2.135.528-4.465.731-6.966a33.854,33.854,0,0,0-.154-7.972,23.982,23.982,0,0,0-3-8.224,34.1,34.1,0,0,0-5.886-7.388c-4.7-4.522-10.189-7.6-15.141-10.294s-9.531-5.017-13.152-7.307a94.369,94.369,0,0,1-8.289-5.853c-.942-.747-1.624-1.348-2.127-1.754l-.544-.471c-.114-.114-.179-.171-.17-.179l.2.146c.146.114.333.252.56.438l2.184,1.689c1.9,1.445,4.7,3.483,8.346,5.732s8.167,4.579,13.176,7.234,10.489,5.756,15.247,10.335a34.721,34.721,0,0,1,5.959,7.477,24.4,24.4,0,0,1,3.028,8.378,34.094,34.094,0,0,1,.114,8.062c-.219,2.517-.544,4.871-.812,6.958a37.645,37.645,0,0,0-.122,10.083,22.052,22.052,0,0,0,.617,2.679c.089.284.154.5.2.682a1.47,1.47,0,0,1,.073.227Z",
    transform: "translate(-106.573 -147.16)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15285",
    "data-name": "Path 15285",
    d: "M84.11,395.94a2.289,2.289,0,0,1,.633-.406,11.367,11.367,0,0,1,1.908-.812,13.371,13.371,0,0,1,6.779-.365,13.582,13.582,0,0,1,6.081,3.012,11.368,11.368,0,0,1,1.429,1.486c.308.39.447.617.422.633a22.5,22.5,0,0,0-2.046-1.884,13.948,13.948,0,0,0-12.576-2.6C85.084,395.477,84.142,396.013,84.11,395.94Z",
    transform: "translate(-78.076 -191.181)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15286",
    "data-name": "Path 15286",
    d: "M98.56,388.92a5.635,5.635,0,0,1,1.486,1.1,15.157,15.157,0,0,1,4.481,7.566,5.8,5.8,0,0,1,.252,1.827A20.622,20.622,0,0,0,98.56,388.92Z",
    transform: "translate(-80.795 -190.21)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15287",
    "data-name": "Path 15287",
    d: "M174.92,462.606s8.622-41.981,26.9-50.1l72.458-2.127s23.941,16.034,27.773,52.462Z",
    transform: "translate(-95.162 -194.248)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15288",
    "data-name": "Path 15288",
    d: "M229.109,254.45s2.135,13.436,16.472,11.812,19.947-9.637,19.947-9.637l19.923,6.389,3.134,38.539a170.2,170.2,0,0,0-18.673,71.321c-.162,4.165-.308,8.736-3.085,11.845a15.046,15.046,0,0,1-6.608,3.791,60.361,60.361,0,0,1-47.412-3.9s-6.089-65.938-5.342-67.806,10.716-57.341,10.716-57.341Z",
    transform: "translate(-101.274 -164.91)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15289",
    "data-name": "Path 15289",
    d: "M183.332,258.2s-12.665.893-16.058,2.59-47.794,57.4-49.523,58.25c-1.413.706-27.838,25.265-38.742,49.036-2.151,4.684-3.816,11.366-.276,15.8,0,0,12.73-15.985,20.377-8.971l34.2-34.658,35.721-20.832Z",
    transform: "translate(-76.678 -165.615)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10410",
    "data-name": "Group 10410",
    transform: "translate(119.603 91.716)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15290",
    "data-name": "Path 15290",
    d: "M224,366.86c15.035-29.032,15.035-71.1,7.867-109.73l-6.43,54.889Z",
    transform: "translate(-224 -257.13)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15291",
    "data-name": "Path 15291",
    d: "M182.226,266.484l1.128,47.087s4.506,52.17,5.374,52.17,3.394,18.38,0,26.58-14.418,19.233-14.418,19.233l13.858,14.987s12.99-20.645,16.968-33.935,14.987-33.359,16.684-70.7,1-73.781,1-73.781l-10.9,7.891-10.473.219Z",
    transform: "translate(-95.048 -163.719)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15292",
    "data-name": "Path 15292",
    d: "M211.418,391.946a1.394,1.394,0,0,1,.114-.447c.114-.292.2-.739.365-1.3l1.372-5.009c1.153-4.36,2.785-10.684,4.295-18.6.755-3.954,1.478-8.313,1.973-12.99.235-2.354.414-4.8.471-7.307a45.593,45.593,0,0,0-.422-7.737,23.649,23.649,0,0,0-.934-3.9,40.52,40.52,0,0,0-1.388-3.889l-.812-1.948-.877-1.932c-.568-1.3-1.218-2.582-1.859-3.881-2.6-5.171-5.634-10.359-8.93-15.555-2.841-4.49-5.756-8.817-8.711-12.908l-.114-.162.154-.122,21.2-17.4.138.325-18.673,2.151-.373.041.235-.292c5.334-6.495,9.661-11.821,12.657-15.5l3.45-4.2.909-1.088c.211-.244.325-.357.325-.357l-.292.39-.869,1.112-3.4,4.165L198.875,279.2l-.138-.244,18.673-2.216.625-.073-.487.4-21.173,17.455.041-.284c2.963,4.1,5.878,8.427,8.727,12.925,3.247,5.2,6.332,10.4,8.93,15.6.649,1.3,1.3,2.582,1.867,3.9l.877,1.94.812,1.957c.552,1.291.958,2.614,1.4,3.913a24.589,24.589,0,0,1,.934,3.962,45.562,45.562,0,0,1,.406,7.8c-.057,2.533-.244,4.985-.487,7.347-.511,4.725-1.25,9.085-2.022,13.046-1.559,7.924-3.247,14.24-4.433,18.591-.609,2.168-1.1,3.848-1.453,4.985-.179.552-.309.982-.406,1.291S211.418,391.946,211.418,391.946Z",
    transform: "translate(-99.121 -165.568)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15293",
    "data-name": "Path 15293",
    d: "M276.023,242.89s7.014,10.814,7.745,11.561c0,0,29.633,8.386,31.386,11.918,7.209,14.565,1.388,19.8,0,39.821-1.729,24.883-10.059,59.517-10.059,59.517s11.723,45.179,12.99,47.672-39.9,17.633-44.27,11.934-7.786-25.33-7.786-25.33-4.059-39.886-2.492-55.774,8.93-32.222,11.528-51.414C277.712,272.514,276.023,242.89,276.023,242.89Z",
    transform: "translate(-111.768 -162.735)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15294",
    "data-name": "Path 15294",
    d: "M265.45,368.884a2.8,2.8,0,0,1,.089-.585c.089-.414.2-.966.341-1.624s.357-1.624.576-2.606.674-2.127,1.072-3.369a80.227,80.227,0,0,1,9.19-18.21,116.9,116.9,0,0,1,12.876-15.855c1.827-1.875,3.369-3.329,4.465-4.3.544-.487.99-.812,1.291-1.088a2.721,2.721,0,0,1,.487-.325s-2.436,2.127-6.024,5.918a126.375,126.375,0,0,0-12.738,15.888,84.9,84.9,0,0,0-9.271,18.039c-.406,1.234-.812,2.346-1.12,3.337s-.463,1.859-.641,2.582-.317,1.218-.422,1.624A4.129,4.129,0,0,1,265.45,368.884Z",
    transform: "translate(-112.196 -177.416)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15295",
    "data-name": "Path 15295",
    d: "M288.5,257.75a2.827,2.827,0,0,1,.3.552c.195.406.455.95.812,1.624.674,1.461,1.624,3.507,2.8,6.016q.885,1.916,1.916,4.157l1.072,2.314c.357.812.763,1.624,1.064,2.484,1.3,3.475,2.728,7.307,4.23,11.277l3.361,9.028.081.219-.227.049-7.916,1.713.114-.244,3.978,8.736c.447,1.023.812,1.843,1.08,2.436l.268.649a.756.756,0,0,1,.073.227.941.941,0,0,1-.122-.2l-.317-.625-1.161-2.395-4.108-8.679-.1-.195.219-.049,7.9-1.762-.138.268-3.41-8.979c-1.486-4-2.9-7.81-4.189-11.277-.3-.885-.7-1.689-1.055-2.492l-1.039-2.322-1.835-4.205c-1.112-2.525-2.03-4.587-2.679-6.056l-.706-1.624A4.058,4.058,0,0,1,288.5,257.75Z",
    transform: "translate(-116.532 -165.531)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15296",
    "data-name": "Path 15296",
    d: "M312.53,372.28s15.157,15.157,22.951,14.289,17.974-17.755,17.974-23.6-7.307-43.531-7.307-43.531l3.028-14.183-28.415-.544L315.079,348.4Z",
    transform: "translate(-121.054 -174.366)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15297",
    "data-name": "Path 15297",
    d: "M316.36,263.22a1.4,1.4,0,0,1-.1.317l-.341.9-.568,1.461c-.252.568-.528,1.226-.852,1.957-.658,1.469-1.518,3.247-2.6,5.261a72.374,72.374,0,0,1-4.059,6.617,78.376,78.376,0,0,1-13.452,15.035,67.247,67.247,0,0,1-9.661,7.014,39.2,39.2,0,0,1-11.885,4.766,27.116,27.116,0,0,1-12.779-.309,22.31,22.31,0,0,1-5.626-2.436,20.3,20.3,0,0,1-4.49-3.783,46.9,46.9,0,0,1-5.967-9.012c-1.624-2.963-3.1-5.748-4.335-8.346a62.334,62.334,0,0,1-2.931-7.193,40.324,40.324,0,0,1-1.429-5.683,25.225,25.225,0,0,1-.39-4.977,2.144,2.144,0,0,1,0,.333,6.471,6.471,0,0,0,.057.958,35.525,35.525,0,0,0,.463,3.661,41.152,41.152,0,0,0,1.494,5.642,64.772,64.772,0,0,0,2.971,7.136c1.25,2.582,2.744,5.35,4.376,8.305a46.6,46.6,0,0,0,5.943,8.93,20.118,20.118,0,0,0,4.416,3.694,21.984,21.984,0,0,0,5.529,2.371,26.791,26.791,0,0,0,12.576.292,39.131,39.131,0,0,0,11.764-4.709,67.894,67.894,0,0,0,9.62-6.949,79.117,79.117,0,0,0,13.452-14.914c1.624-2.354,2.971-4.587,4.108-6.56s1.973-3.759,2.655-5.212c.333-.731.625-1.38.885-1.94l.6-1.445.382-.885a1.516,1.516,0,0,1,.171-.3Z",
    transform: "translate(-106.446 -166.56)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15298",
    "data-name": "Path 15298",
    d: "M318.657,263.111a3.872,3.872,0,0,1-.479.528l-1.413,1.445-5.293,5.253-7.818,7.794a32.179,32.179,0,0,1-5.131,4.059,15.133,15.133,0,0,1-6.625,2.362,11.626,11.626,0,0,1-6.893-1.323,8.329,8.329,0,0,1-3.954-5.155,22.731,22.731,0,0,1-.666-5.9c0-1.851.065-3.572.1-5.147a28.2,28.2,0,0,0-.52-7.372,10.9,10.9,0,0,0-.69-1.883,6.4,6.4,0,0,1-.284-.649,3.674,3.674,0,0,1,.357.609,9.215,9.215,0,0,1,.771,1.884,26.881,26.881,0,0,1,.666,7.42c0,1.575-.073,3.3-.049,5.139a22.732,22.732,0,0,0,.69,5.789,7.956,7.956,0,0,0,3.783,4.912,11.285,11.285,0,0,0,6.649,1.258,14.841,14.841,0,0,0,6.446-2.289,32.1,32.1,0,0,0,5.082-4.011c1.51-1.413,2.858-2.866,4.2-4.132s2.565-2.484,3.694-3.58l5.374-5.163,1.469-1.388A5.791,5.791,0,0,1,318.657,263.111Z",
    transform: "translate(-114.743 -165.412)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15299",
    "data-name": "Path 15299",
    d: "M193.548,380.2a.812.812,0,0,1-.049-.219l-.1-.658c-.073-.609-.179-1.461-.317-2.533-.276-2.241-.666-5.415-1.145-9.328-.958-7.875-2.314-18.762-3.588-30.8-.641-6.024-1.177-11.764-1.624-17s-.731-9.945-.9-13.915c-.114-1.981-.171-3.775-.219-5.35s-.089-2.931-.089-4.059v-3.215a1.179,1.179,0,0,1,0-.227.762.762,0,0,1,0,.219,4.188,4.188,0,0,0,.041.666q0,.926.1,2.557c0,1.1.081,2.436.162,4.059s.154,3.369.276,5.342c.211,3.962.576,8.671,1,13.9s1,10.968,1.624,16.992c1.283,12.032,2.59,22.919,3.467,30.8.422,3.921.812,7.112,1.015,9.344.106,1.08.187,1.932.244,2.549a3.586,3.586,0,0,0,.049.658.682.682,0,0,1,.057.219Z",
    transform: "translate(-97.155 -172.142)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15300",
    "data-name": "Path 15300",
    d: "M349.65,305.205h-2.078l-5.829-.057-20.54-.309.195-.154c-1.153,6.1-2.086,13.046-2.809,20.394-1.283,13.485-1.819,25.744-2.476,34.6-.317,4.433-.617,8.013-.812,10.481-.122,1.218-.227,2.168-.292,2.85-.041.3-.065.544-.089.739a1.243,1.243,0,0,1-.041.244.968.968,0,0,1,0-.252,5.259,5.259,0,0,1,.041-.739c.057-.682.13-1.624.219-2.85.187-2.436.438-6.065.714-10.489.585-8.857,1.072-21.108,2.362-34.625.714-7.363,1.664-14.321,2.85-20.426v-.162h.162l20.532.463,5.837.162,1.543.057h.4C349.609,305.189,349.65,305.2,349.65,305.205Z",
    transform: "translate(-121.494 -174.317)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 2.224,
    cy: 2.224,
    r: 2.224,
    transform: "translate(218.99 136.733)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15301",
    "data-name": "Path 15301",
    d: "M350.825,314.762a4.873,4.873,0,0,1-.146-.528,2.257,2.257,0,0,0-.812-1.129,2.087,2.087,0,0,0-1.948-.252,2.038,2.038,0,0,0,0,3.816,2.086,2.086,0,0,0,1.948-.26,2.224,2.224,0,0,0,.812-1.128,4.355,4.355,0,0,1,.146-.52,1.113,1.113,0,0,1,0,.56,2.3,2.3,0,0,1-.812,1.331,2.363,2.363,0,0,1-2.265.382,2.436,2.436,0,0,1,0-4.546,2.362,2.362,0,0,1,2.265.382,2.257,2.257,0,0,1,.812,1.323C350.906,314.559,350.849,314.762,350.825,314.762Z",
    transform: "translate(-127.386 -175.804)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 2.224,
    cy: 2.224,
    r: 2.224,
    transform: "translate(155.763 205.205)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15302",
    "data-name": "Path 15302",
    d: "M272.925,399.1s-.049-.195-.154-.52a2.257,2.257,0,0,0-.812-1.128,2.046,2.046,0,1,0,0,3.3,2.257,2.257,0,0,0,.812-1.128c.106-.325.114-.528.154-.528a1.08,1.08,0,0,1,0,.568,2.217,2.217,0,0,1-.812,1.323,2.354,2.354,0,0,1-2.257.39,2.436,2.436,0,0,1,0-4.554,2.354,2.354,0,0,1,2.257.39,2.216,2.216,0,0,1,.812,1.323,1.023,1.023,0,0,1,0,.56Z",
    transform: "translate(-112.729 -191.673)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15303",
    "data-name": "Path 15303",
    d: "M278.655,440.893a2.233,2.233,0,1,1-2.233-2.233A2.233,2.233,0,0,1,278.655,440.893Z",
    transform: "translate(-113.84 -199.569)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15304",
    "data-name": "Path 15304",
    d: "M278.613,440.851c-.041,0-.049-.2-.154-.528a2.208,2.208,0,0,0-.812-1.128,2.054,2.054,0,1,0-1.948,3.564,2.086,2.086,0,0,0,1.948-.26,2.176,2.176,0,0,0,.812-1.128c.106-.325.114-.528.154-.52a1.023,1.023,0,0,1,0,.56,2.192,2.192,0,0,1-.812,1.323,2.371,2.371,0,0,1-2.265.39,2.436,2.436,0,0,1,0-4.555,2.371,2.371,0,0,1,2.265.39,2.192,2.192,0,0,1,.812,1.323A1.08,1.08,0,0,1,278.613,440.851Z",
    transform: "translate(-113.797 -199.527)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15305",
    "data-name": "Path 15305",
    d: "M347.979,322.565c0,.122-5.829-.057-12.99-.382s-12.99-.69-12.99-.812,5.829.057,12.99.39S347.979,322.451,347.979,322.565Z",
    transform: "translate(-122.835 -177.494)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15306",
    "data-name": "Path 15306",
    d: "M178.131,361.467l-8.378,3.345L151.527,319.2a20.981,20.981,0,0,0-38.969,15.563l18.226,45.61-8.378,3.353-18.234-45.61a29.992,29.992,0,0,1,55.7-22.261Z",
    transform: "translate(-81.447 -172.913)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15307",
    "data-name": "Path 15307",
    d: "M178.12,361.427l-.373-.909-1.064-2.671-4.059-10.132c-1.77-4.4-3.937-9.742-6.446-16.01q-1.884-4.676-4.011-9.986c-1.486-3.5-2.687-7.4-4.993-10.936a29.227,29.227,0,0,0-9.377-9.166c-.5-.3-.982-.609-1.486-.893l-1.575-.771a29.224,29.224,0,0,0-3.247-1.323c-.56-.211-1.153-.325-1.729-.5A11.866,11.866,0,0,0,138,297.7a28.649,28.649,0,0,0-3.653-.487,30.85,30.85,0,0,0-7.518.357l-1.875.438-.942.219-.926.309-1.851.641c-.609.235-1.193.536-1.794.812a29.729,29.729,0,0,0-15.92,35.324c.893,2.825,2.111,5.61,3.247,8.443l14,35.039,1.916,4.782-.276-.114,8.378-3.353-.114.276c-3.629-9.068-7.169-17.95-10.619-26.572l-5.082-12.746-2.484-6.211A22.951,22.951,0,0,1,111,328.417a21.287,21.287,0,0,1,2.98-12.34,14.251,14.251,0,0,1,.812-1.331l.934-1.25a23.194,23.194,0,0,1,4.563-4.132c.422-.292.869-.528,1.307-.812l.649-.382.69-.317a21.222,21.222,0,0,1,5.683-1.8,22.352,22.352,0,0,1,5.788-.154,21.3,21.3,0,0,1,10.237,4.059,20.3,20.3,0,0,1,6.552,8c.17.382.349.763.52,1.137s.309.771.455,1.153l.909,2.265q.885,2.257,1.754,4.408l6.3,15.823c3.783,9.547,6.746,17.049,8.719,21.985l-.081-.041,6.332-2.492,1.551-.6.52-.195-.487.211c-.341.138-.812.341-1.526.625l-6.341,2.565h-.057v-.057c-2-4.952-4.993-12.405-8.825-21.92-1.916-4.766-4.059-10.051-6.349-15.807l-1.762-4.4c-.3-.747-.609-1.5-.909-2.265l-.463-1.153c-.17-.373-.341-.747-.52-1.12a21.2,21.2,0,0,0-2.663-4.295,21.83,21.83,0,0,0-3.8-3.58,21.108,21.108,0,0,0-10.083-3.954,22.26,22.26,0,0,0-5.683.162,21.058,21.058,0,0,0-5.561,1.778l-.674.309-.641.382c-.422.26-.869.5-1.283.771a22.581,22.581,0,0,0-2.362,1.875,21.59,21.59,0,0,0-2.111,2.192l-.917,1.234a11.517,11.517,0,0,0-.812,1.3,20.954,20.954,0,0,0-2.915,12.121A22.878,22.878,0,0,0,112.9,334.7c.812,2.054,1.624,4.132,2.492,6.219l5.09,12.738,10.627,26.572.081.195-.195.081c-2.728,1.08-5.529,2.208-8.378,3.345l-.2.081-.073-.195-1.916-4.79c-4.8-12-9.474-23.722-14-35.039-1.112-2.841-2.322-5.594-3.247-8.484a32.1,32.1,0,0,1-1.218-8.825,32.6,32.6,0,0,1,1.372-8.622,32,32,0,0,1,3.661-7.7,29.933,29.933,0,0,1,12.3-10.627c.617-.268,1.21-.568,1.827-.812l1.867-.641c.317-.1.625-.219.934-.309l.958-.219,1.9-.438a30.848,30.848,0,0,1,7.615-.357,27.946,27.946,0,0,1,3.686.5,16.823,16.823,0,0,1,1.786.43c.585.179,1.185.292,1.745.5a32.406,32.406,0,0,1,3.329,1.348l1.624.812c.5.284,1,.609,1.494.9a29.567,29.567,0,0,1,9.458,9.288c2.322,3.6,3.515,7.51,4.993,11.025l3.994,10.034c2.484,6.259,4.619,11.65,6.373,16.058l4,10.132,1.039,2.63A7.526,7.526,0,0,0,178.12,361.427Z",
    transform: "translate(-81.435 -172.873)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8741",
    "data-name": "Rectangle 8741",
    width: 84.822,
    height: 69.129,
    rx: 10.01,
    transform: "translate(20.948 185.752) rotate(-21.79)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10411",
    "data-name": "Group 10411",
    transform: "translate(20.948 154.265)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8742",
    "data-name": "Rectangle 8742",
    width: 84.822,
    height: 69.129,
    rx: 10.39,
    transform: "translate(0 31.487) rotate(-21.79)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8743",
    "data-name": "Rectangle 8743",
    width: 78.693,
    height: 69.129,
    rx: 9.98,
    transform: "translate(17.362 187.184) rotate(-21.79)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10412",
    "data-name": "Group 10412",
    transform: "translate(55.969 188.855)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15308",
    "data-name": "Path 15308",
    d: "M164.252,382.894a9.653,9.653,0,1,0-7.98,13.144L160.647,407a2.639,2.639,0,0,0,3.426,1.461h0a2.63,2.63,0,0,0,1.469-3.418l-4.384-10.96a9.629,9.629,0,0,0,3.093-11.187Z",
    transform: "translate(-145.618 -376.782)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15309",
    "data-name": "Path 15309",
    d: "M212.164,398.788c-.114.041-4.619-11.122-10.067-24.932s-9.791-25.046-9.677-25.086,4.611,11.122,10.067,24.932S212.269,398.747,212.164,398.788Z",
    transform: "translate(-98.454 -182.656)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15310",
    "data-name": "Path 15310",
    d: "M166.264,394.656a15.741,15.741,0,0,0,2.289-3.044,11.764,11.764,0,0,0,1.3-3.889,10.554,10.554,0,0,0-2.963-9.214,11.7,11.7,0,0,0-3.312-2.436,16.37,16.37,0,0,0-3.637-1.145,4.36,4.36,0,0,1,1.039.065,9.961,9.961,0,0,1,2.72.812,11.6,11.6,0,0,1,3.467,2.436,10.741,10.741,0,0,1,3.069,9.555,11.366,11.366,0,0,1-1.421,3.97,9.829,9.829,0,0,1-1.745,2.241,4.061,4.061,0,0,1-.8.649Z",
    transform: "translate(-92.344 -187.576)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15311",
    "data-name": "Path 15311",
    d: "M158.076,349.47c.041.106-9.7,4.254-21.766,9.263s-21.92,8.987-21.92,8.882,9.7-4.254,21.774-9.271S158.027,349.364,158.076,349.47Z",
    transform: "translate(-83.774 -182.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15312",
    "data-name": "Path 15312",
    d: "M147.509,395.478a2.435,2.435,0,0,1-.6-.414,9.344,9.344,0,0,1-1.364-1.421,10.789,10.789,0,0,1-.812-12.283,9.44,9.44,0,0,1,1.177-1.583,2.183,2.183,0,0,1,.536-.487c.065.057-.674.812-1.453,2.216a11.114,11.114,0,0,0,.771,11.959C146.738,394.788,147.558,395.413,147.509,395.478Z",
    transform: "translate(-89.193 -188.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15313",
    "data-name": "Path 15313",
    d: "M154.379,402.589c0,.122-.633.114-1.372,0s-1.331-.317-1.307-.438.633-.106,1.372,0S154.379,402.475,154.379,402.589Z",
    transform: "translate(-90.793 -192.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15314",
    "data-name": "Path 15314",
    d: "M119.183,303a15.42,15.42,0,0,1-1.421.812,27.655,27.655,0,0,0-3.661,2.517,26.442,26.442,0,0,0-7.664,30.485c.4.974.649,1.5.617,1.518a1.841,1.841,0,0,1-.219-.365c-.13-.244-.341-.6-.552-1.088a23.9,23.9,0,0,1-1.478-4.238,25.573,25.573,0,0,1,9.133-26.564,23.925,23.925,0,0,1,3.767-2.436c.471-.252.852-.406,1.1-.52a2.054,2.054,0,0,1,.373-.122Z",
    transform: "translate(-81.82 -174.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15315",
    "data-name": "Path 15315",
    d: "M110.389,355.441a7.875,7.875,0,0,1-1.1-2.265,7.7,7.7,0,0,1-.714-2.436,7.412,7.412,0,0,1,1.1,2.265A7.753,7.753,0,0,1,110.389,355.441Z",
    transform: "translate(-82.679 -183.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10413",
    "data-name": "Group 10413",
    transform: "translate(86.482 124.442)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15316",
    "data-name": "Path 15316",
    d: "M185.173,297.44c-3.645,10.432-1.843,22.163,2.216,32.474C187.39,329.882,185.271,308.359,185.173,297.44Z",
    transform: "translate(-183.202 -297.44)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10414",
    "data-name": "Group 10414",
    transform: "translate(152.232 130.084)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15317",
    "data-name": "Path 15317",
    d: "M264.239,374.907c4.019-9.076,8.045-18.185,13.225-26.653s11.366-16.513,19.281-22.464c2.143-1.624,6.146-4.644,6.146-4.644s-1.072-2.03-2.127-3.71c-1.218-1.948-3.247-5.326-4.319-6.99l4.749.95s-3.247-7.485-3.158-6.982a63.122,63.122,0,0,1-6.438,1.323c1.664,3.978,3.434,7.575,5.1,11.553-8.93,7.1-16.237,16.042-22.358,25.492S263.979,363.2,264.2,374.445",
    transform: "translate(-264.19 -304.39)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15318",
    "data-name": "Path 15318",
    d: "M283.784,215.459c.106-.089.357,0,.641.317a2.63,2.63,0,0,1,.552,1.721,3.174,3.174,0,0,1-.276,1.3,3.32,3.32,0,0,1-1,1.258,3.613,3.613,0,0,1-5.8-2.2,3.247,3.247,0,0,1,.739-2.76,2.655,2.655,0,0,1,1.551-.917c.43-.057.666.049.7.187.065.292-.633.666-1.015,1.575a1.989,1.989,0,0,0-.081,1.469,1.859,1.859,0,0,0,2.785,1.047,1.965,1.965,0,0,0,.917-1.145C283.808,216.376,283.532,215.654,283.784,215.459Z",
    transform: "translate(-114.528 -157.329)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15319",
    "data-name": "Path 15319",
    d: "M104.57,429.48s2.768,8.93,4.2,10.725,10.984,2.76,10.984,2.76Z",
    transform: "translate(-81.926 -197.841)",
    fill: "#d0937e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15320",
    "data-name": "Path 15320",
    d: "M116.318,412l5.3,4.254,15.734,12.129s-.1,2.923-3.637,2.257c-2.874-.544-9.247-4.059-9.247-4.059s7.485,7.031,7.745,10.319v.6a2.785,2.785,0,0,1-.812,1.94h0l-8.744-5.837s1.875,3.3,3.718,6.714a4.2,4.2,0,0,1-.6,4.173h0l-19.484-16.343-.122-12.178,10.108-3.978",
    transform: "translate(-82.227 -194.551)",
    fill: "#d0937e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15321",
    "data-name": "Path 15321",
    d: "M116.12,421.4a2.439,2.439,0,0,1,.731.162c.227.081.5.2.812.341s.641.341,1.015.552c1.478.877,3.353,2.3,5.431,3.856a47.962,47.962,0,0,0,5.48,3.686c1.486.812,2.492,1.12,2.436,1.193a2.435,2.435,0,0,1-.723-.162,6.852,6.852,0,0,1-.812-.292,10.194,10.194,0,0,1-1.055-.471,37.1,37.1,0,0,1-5.61-3.613c-2.078-1.567-3.913-3.02-5.334-3.946l-.966-.593-.763-.4a2.891,2.891,0,0,1-.641-.317Z",
    transform: "translate(-84.099 -196.321)",
    fill: "#884c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15322",
    "data-name": "Path 15322",
    d: "M113.92,428.71a9.052,9.052,0,0,1,1.689,1.047c1,.69,2.346,1.7,3.783,2.866s2.7,2.281,3.58,3.118a8.426,8.426,0,0,1,1.356,1.421,9.377,9.377,0,0,1-1.559-1.193l-3.645-3.02-3.694-2.955A9.824,9.824,0,0,1,113.92,428.71Z",
    transform: "translate(-83.685 -197.697)",
    fill: "#884c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15323",
    "data-name": "Path 15323",
    d: "M81.539,408.359c-.138.154.065.447.195.723,2.119,4.425,20.3,16.992,20.3,16.992l9.913-16.895s7.2,3.483,10.156,2.679c2.436-.666,7.014-1.161,4.871-5.431,0,0-10.156-1.867-13.607-3.353s-5.61-2.257-5.61-2.257a48.224,48.224,0,0,1-11.723-1.161S89.958,398.8,81.539,408.359Z",
    transform: "translate(-77.584 -192.226)",
    fill: "#d0937e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15324",
    "data-name": "Path 15324",
    d: "M126.211,448.57a21.414,21.414,0,0,1-2.3-1.786c-1.494-1.21-3.377-2.744-5.472-4.433s-4.059-3.337-5.391-4.538c-.674-.593-1.21-1.088-1.575-1.437a3.018,3.018,0,0,1-.536-.576,20.914,20.914,0,0,1,2.306,1.786l5.464,4.433c2.135,1.737,4.059,3.337,5.391,4.538.674.593,1.218,1.088,1.575,1.437A3.023,3.023,0,0,1,126.211,448.57Z",
    transform: "translate(-83.124 -199.031)",
    fill: "#884c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15325",
    "data-name": "Path 15325",
    d: "M336.435,226.725l6.259.982.755-4.782-2.436-.382.341-2.176-2.257-.357.3-1.908,2.606.406.26-1.624-4.173-.658.1-.625-.1.625h0l.1-.625a1.5,1.5,0,0,0-1.356-1.624,1.534,1.534,0,0,0-1.624,1.356q-1.819,11.609-3.645,23.195l-.974,6.186a8.119,8.119,0,1,0,2.931.463q1.413-8.93,2.817-17.861h0Zm.349,27.027a6.032,6.032,0,1,1-5.025-6.9h0a6.04,6.04,0,0,1,5.025,6.925Z",
    transform: "translate(-122.965 -157.294)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15326",
    "data-name": "Path 15326",
    d: "M336.435,226.725l6.259.982.755-4.782-2.436-.382.341-2.176-2.257-.357.3-1.908,2.606.406.26-1.624-4.173-.658.1-.625-.1.625h0l.1-.625a1.5,1.5,0,0,0-1.356-1.624,1.534,1.534,0,0,0-1.624,1.356q-1.819,11.609-3.645,23.195l-.974,6.186a8.119,8.119,0,1,0,2.931.463q1.413-8.93,2.817-17.861h0Zm.349,27.027a6.032,6.032,0,1,1-5.025-6.9h0a6.04,6.04,0,0,1,5.025,6.925Z",
    transform: "translate(-122.965 -157.294)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15327",
    "data-name": "Path 15327",
    d: "M337.232,261.3a8,8,0,0,0-.268-2.549,5.8,5.8,0,0,0-1.486-2.484,5.861,5.861,0,0,0-3.3-1.681l.106-.349h0l1.258.552-1.364-.2a5.837,5.837,0,0,0-6.073,8.451,5.683,5.683,0,0,0,2.354,2.436,5.87,5.87,0,0,0,5.6.073,6.08,6.08,0,0,0,2.679-2.841,13.81,13.81,0,0,0,.487-1.4,1.358,1.358,0,0,1,0,.382,5.213,5.213,0,0,1-.3,1.08,6.04,6.04,0,0,1-2.687,3.036,6.2,6.2,0,1,1-1.981-11.577l-.106.349h0l-1.315-.6,1.421.252a6.154,6.154,0,0,1,3.458,1.835A6.016,6.016,0,0,1,337.2,258.7a6.154,6.154,0,0,1,.179,1.932A3.029,3.029,0,0,1,337.232,261.3Z",
    transform: "translate(-123.413 -164.821)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15328",
    "data-name": "Path 15328",
    d: "M336.4,226.677a4.01,4.01,0,0,1-.065.585h0c-.227,1.762-1.21,8.248-2.7,17.861l-.089-.162a8.159,8.159,0,1,1-3.889-.455c.3-.049.6-.057.893-.081l-.2.179c1.039-6.56,2.038-12.884,2.971-18.811.471-2.963.926-5.829,1.364-8.573.106-.69.219-1.364.325-2.038a1.713,1.713,0,0,1,1.5-1.453,1.672,1.672,0,0,1,1.729,1.088,1.762,1.762,0,0,1,0,1.039v.3h0l-.349-.049v-.162l.081-.471.341.057-.1.625-.146-.195,4.173.666h.162v.162c-.1.585-.179,1.12-.268,1.624v.154h-.154l-2.606-.422.17-.122c-.114.69-.211,1.307-.309,1.908l-.122-.162,2.265.365h.13v.138c-.13.812-.244,1.494-.357,2.168l-.106-.146,2.436.4h.114v.114q-.455,2.728-.812,4.782v.089H342.7l-4.619-.812-1.21-.211-.414-.081h.39l1.193.171,4.693.682-.106.073c.211-1.372.447-2.963.723-4.782l.1.13-2.436-.365h-.122v-.122l.333-2.176.114.154-2.257-.349h-.146v-.138c.089-.609.187-1.226.292-1.916v-.146h.146l2.614.4-.187.13c.089-.528.17-1.064.26-1.624l.138.187-4.181-.649h-.17v-.171l.1-.633.341.057-.073.471v.162c-.7-.114-.187,0-.349-.065h0v-.292a1.469,1.469,0,0,0,0-.861,1.307,1.307,0,0,0-1.356-.852,1.34,1.34,0,0,0-1.177,1.153l-.317,2.03-1.34,8.581c-.926,5.926-1.924,12.251-2.947,18.811v.162h-.179a3.4,3.4,0,0,0-.852.073,7.773,7.773,0,1,0,3.726.317l-.114-.041v-.122c1.543-9.612,2.606-16.091,2.923-17.861h0A4.314,4.314,0,0,0,336.4,226.677Z",
    transform: "translate(-122.935 -157.246)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15329",
    "data-name": "Path 15329",
    d: "M322.572,258.049l10.034-2.639,5.212.666a2.833,2.833,0,0,1,2.2,1.624l3.377,7.355s4.871,4.059,4.311,6.495-5.082,24.291-5.082,24.291l-13.452-.406a18.559,18.559,0,0,1-4.059-10.213c-.146-3.069,1.023-4.944.731-6.568-.195-1.112.5-3.093.812-4.619l.406-1.478-.893.43a2.72,2.72,0,0,1-3.881-2.038,2.3,2.3,0,0,1,0-.235h0a6.105,6.105,0,0,1,1.827-4.676l5.074-4.985S323.579,264.251,322.572,258.049Z",
    transform: "translate(-122.888 -165.09)",
    fill: "#d0937e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15330",
    "data-name": "Path 15330",
    d: "M340.533,273.206a3.613,3.613,0,0,1-.934-.106l-2.492-.447-3.694-.714c-.69-.13-1.421-.317-2.16-.382a2.314,2.314,0,0,0-2.005.641,4.587,4.587,0,0,0-.812,2.078c-.162.755-.317,1.478-.463,2.176a23.582,23.582,0,0,0-.658,3.653,2.525,2.525,0,0,0,.966,2.119,2.646,2.646,0,0,0,.812.349.438.438,0,0,1-.243,0,1.486,1.486,0,0,1-.674-.227A2.622,2.622,0,0,1,327,280.115a20.494,20.494,0,0,1,.568-3.743c.138-.7.284-1.429.438-2.176a4.871,4.871,0,0,1,.942-2.281,2.7,2.7,0,0,1,2.354-.763,19.9,19.9,0,0,1,2.208.406l3.67.812,2.436.576A3.986,3.986,0,0,1,340.533,273.206Z",
    transform: "translate(-123.776 -168.045)",
    fill: "#884c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15331",
    "data-name": "Path 15331",
    d: "M335.629,285.279a1.14,1.14,0,0,1-.511.812,1.826,1.826,0,0,1-1.112.317,5.386,5.386,0,0,1-1.469-.284,5.683,5.683,0,0,1-3.207-2.176,5.074,5.074,0,0,1-.065-4.7,8.984,8.984,0,0,1,1.25-2.151,2.436,2.436,0,0,1,1.015-.723,2.582,2.582,0,0,1,1.185-.081,18.1,18.1,0,0,1,3.686,1.177,19.2,19.2,0,0,1,2.314,1.169,3.247,3.247,0,0,1,.812.544c0,.065-1.185-.649-3.207-1.437a20.111,20.111,0,0,0-3.621-1.072,2.217,2.217,0,0,0-1.007.081,2.03,2.03,0,0,0-.812.617,8.727,8.727,0,0,0-1.169,2.038,4.741,4.741,0,0,0,0,4.327,5.5,5.5,0,0,0,2.963,2.1,5.68,5.68,0,0,0,1.388.333,1.745,1.745,0,0,0,1.015-.219,1.624,1.624,0,0,0,.552-.674Z",
    transform: "translate(-124.099 -169.013)",
    fill: "#884c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15332",
    "data-name": "Path 15332",
    d: "M336.168,285.107c0,.049-.235.187-.69.235A3.069,3.069,0,0,1,332.5,283.8c-.219-.39-.252-.674-.2-.69a4.97,4.97,0,0,0,1.664,1.526A6.494,6.494,0,0,0,336.168,285.107Z",
    transform: "translate(-124.769 -170.302)",
    fill: "#884c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15333",
    "data-name": "Path 15333",
    d: "M337.9,288.331c-.065.089-.7-.284-1.153-1.039s-.511-1.494-.4-1.5.341.6.755,1.283S337.98,288.234,337.9,288.331Z",
    transform: "translate(-125.526 -170.806)",
    fill: "#884c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15334",
    "data-name": "Path 15334",
    d: "M337.756,296.4a7.81,7.81,0,0,1,.235-7.307,25.373,25.373,0,0,0-.6,3.629A25.394,25.394,0,0,0,337.756,296.4Z",
    transform: "translate(-125.65 -171.427)",
    fill: "#884c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15335",
    "data-name": "Path 15335",
    d: "M336.407,289.9a9.523,9.523,0,0,0-5.277,5.155,2.322,2.322,0,0,1,.26-1.12,7.015,7.015,0,0,1,1.559-2.3,6.908,6.908,0,0,1,2.33-1.5A2.241,2.241,0,0,1,336.407,289.9Z",
    transform: "translate(-124.553 -171.579)",
    fill: "#884c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15336",
    "data-name": "Path 15336",
    d: "M332.433,269.31c.122,0,.187.414.049.885s-.406.812-.511.731,0-.422.106-.812S332.319,269.3,332.433,269.31Z",
    transform: "translate(-124.703 -167.705)",
    fill: "#884c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15337",
    "data-name": "Path 15337",
    d: "M344.057,268.1a12.266,12.266,0,0,1-2.005-1.072c-1.218-.7-2.874-1.7-4.684-2.825a15.793,15.793,0,0,0-2.63-1.372,5.967,5.967,0,0,0-2.338-.406,5.545,5.545,0,0,0-2.119.585,1.566,1.566,0,0,1,.479-.39,3.912,3.912,0,0,1,1.624-.5,5.967,5.967,0,0,1,2.484.341,14.079,14.079,0,0,1,2.72,1.38c1.819,1.12,3.45,2.16,4.619,2.931A12.851,12.851,0,0,1,344.057,268.1Z",
    transform: "translate(-124.393 -166.351)",
    fill: "#884c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15338",
    "data-name": "Path 15338",
    d: "M339.61,227.471a36.532,36.532,0,0,1,.6-5.488,34.608,34.608,0,0,1,1.023-5.423,36.674,36.674,0,0,1-.6,5.488,36.021,36.021,0,0,1-1.023,5.423Z",
    transform: "translate(-126.149 -157.781)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10415",
    "data-name": "Group 10415",
    transform: "translate(213.518 59.055)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15339",
    "data-name": "Path 15339",
    d: "M341.247,216.9A13.128,13.128,0,0,1,339.68,227c.585-2.963,1.169-6.974,1.567-10.1",
    transform: "translate(-339.68 -216.9)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeygirl);
export default __webpack_public_path__ + "static/media/keygirl.c6ea65d7f74126e3f5e1249d4c32ef84.svg";
export { ForwardRef as ReactComponent };